import { render, staticRenderFns } from "./EditCallForwardingDialog.vue?vue&type=template&id=7cca6e6a&"
import script from "./EditCallForwardingDialog.vue?vue&type=script&lang=ts&"
export * from "./EditCallForwardingDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports